import { useEffect, useState } from "react";
import axios from "axios";
import useReveal from "../../hooks/useReveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Clients() {
  const [items, setItems] = useState([]);
  const { ref, visible } = useReveal();

  useEffect(() => {
    axios.get(`${API}/public/clients`).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (!items.length) {
    // Don't render the section at all if there are no clients — keeps the page tidy
    return null;
  }

  // Duplicate the list to allow seamless marquee scroll
  const loop = [...items, ...items];

  return (
    <section ref={ref} className="py-20 lg:py-24 bg-[#F8FAFC]" data-testid="home-clients">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center max-w-2xl mx-auto transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#0EA5E9]/10 text-[#0369A1] text-xs tracking-[0.2em] uppercase font-semibold">
            <span className="w-1.5 h-1.5 rounded-full bg-[#0EA5E9]" /> Our clients
          </div>
          <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1F2937] leading-[1.1]" style={{ fontFamily: "'Manrope', sans-serif" }}>
            Trusted across the healthcare ecosystem
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#4B5563]">
            Hospitals, clinicians, distributors and care institutions partner with us for consistency and reach.
          </p>
        </div>

        {/* Marquee */}
        <div className="mt-12 relative overflow-hidden" data-testid="clients-marquee">
          <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-r from-[#F8FAFC] to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-l from-[#F8FAFC] to-transparent z-10 pointer-events-none" />
          <div className="flex gap-8 lg:gap-12 animate-[marquee_35s_linear_infinite] hover:[animation-play-state:paused]">
            {loop.map((c, i) => (
              <a
                key={`${c.id}-${i}`}
                href={c.website || "#"}
                target={c.website ? "_blank" : undefined}
                rel="noreferrer"
                className="group shrink-0 flex flex-col items-center justify-center min-w-[180px] sm:min-w-[220px] h-24 sm:h-28 px-6 bg-white rounded-2xl border border-[#E2E8F0] hover:border-[#C2410C] hover:shadow-md transition-all duration-300"
                title={c.name}
                data-testid={`client-${c.id}`}
              >
                {c.logo_url ? (
                  <img
                    src={`${BACKEND}${c.logo_url}`}
                    alt={c.name}
                    loading="lazy"
                    className="max-h-12 sm:max-h-14 max-w-[160px] object-contain grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                  />
                ) : (
                  <span className="text-sm font-semibold text-[#4B5563] group-hover:text-[#C2410C] transition-colors duration-200">
                    {c.name}
                  </span>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
